<template>
  <a-config-provider :locale="zhCN" :theme="{algorithm: theme.defaultAlgorithm}">
    <router-view/>
  </a-config-provider>
  <div id="captcha"/>
</template>

<script setup lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import {printWelcome} from "@/lib/util";
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn'
import {theme} from "ant-design-vue";

dayjs.locale('zh-cn')
printWelcome()
</script>

<style lang="sass">
@import "main"
body
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif

#app
  height: 100vh
  min-width: 1280px
  display: flex
  flex-direction: column
  position: relative
  background-color: $background

</style>